export default {
  titleContent: {
    type: String,
    default: 'incluido'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/components/resources/props.js